<template>
    <div>
        <h1 class="display-heading">System Settings</h1>

        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Setting</th>
                        <th scope="col">Value</th>
                        <th scope="col">Update Setting</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(setting, index) in settingList" :key="index">
                        <th scope="row">{{index+1}}</th>
                        <td>{{setting.name}}</td>
                        <td>
                            {{setting.value}}
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-primary-insv" @click="updateSetting(setting)">
                                Update
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="modal fade" id="updateSettingModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <form @submit.prevent="submitSettingUpdate">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Update Setting</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <label>{{inputName}}</label>

                            <input type="text"
                                name="inputSetting"
                                ref="inputSetting"
                                data-vv-validate-on="blur"
                                data-vv-as="setting value"
                                placeholder="Enter value" v-model="inputValue" v-validate="`required|${inputvalidationRule}`"
                                :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('inputSetting')
                                }">

                            <div v-show="validationErrors.has('inputSetting')" class="invalid-feedback">
                                {{ validationErrors.first('inputSetting') }}
                            </div>

                            <div class="text-danger mt-3" v-show="updateError">{{updateErrorMessage}}</div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button class="btn btn-primary btn-primary-insv">Save changes</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    data () {
        return {
            'settingList': [],
            'inputName': '',
            'inputvalidationRule': '',
            'inputValue': '',
            'settingBeingUpdated': null,
            'updateError': false,
            'updateErrorMessage': ''
        };
    },
    mounted () {
        this.axios.get('/SystemSetting/GetAllSettings').then(({
            data
        }) => {
            if (data.data) {
                const settings = data.data;

                this.settingList = settings.map((s) => ({
                    'setting': s.s,
                    'value': s.v,
                    'name': s.n,
                    'description': s.d,
                    'validation': s.r
                }));
            }
        });
    },
    'methods': {
        updateSetting (settingObj) {
            let { name, value, validation } = settingObj;

            this.settingBeingUpdated = settingObj;
            this.inputName = name;
            this.inputValue = value;
            this.inputvalidationRule = validation;

            $('#updateSettingModal').modal('show');
        },
        submitSettingUpdate () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.updateError = false;
                    this.axios.post('SystemSetting/UpdateSetting', {
                        's': this.settingBeingUpdated.setting,
                        'v': this.inputValue
                    }).then(() => {
                        this.settingBeingUpdated.value = this.inputValue;
                        $('#updateSettingModal').modal('hide');
                    }).catch(({ response }) => {
                        this.updateError = true;
                        this.updateErrorMessage = response.data ? response.data.message : '';
                    });
                }
            });
        }
    }
};

</script>
